module.exports = __webpack_public_path__ + "static/media/lst_img_07.4f21add8.png";